import { createAction, createReducer } from "@reduxjs/toolkit";
import { updateExternalTeacher } from "./update-external-teacher";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = {
  processing: "idle",
};

export const resetUpdateExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetUpdate");

export const updateExternalTeacherReducer = createReducer(initialState, builder => {
  builder
    .addCase(updateExternalTeacher.pending, state => {
      state.processing = "pending";
    })
    .addCase(updateExternalTeacher.fulfilled, state => {
      state.processing = "success";
    })
    .addCase(updateExternalTeacher.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetUpdateExternalTeacher, () => {
      return initialState;
    });
});
